import { alpha } from '@mui/material/styles';
import { Box, CircularProgress } from '@mui/material';

/** Спиннер по центру на весь экран с мягкой glass-подложкой. */
export default function FullPageLoader() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 20000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: alpha('#090b0d', 0.28),
        backdropFilter: 'blur(20px) saturate(140%)',
        WebkitBackdropFilter: 'blur(20px) saturate(140%)',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(circle at top, rgba(255,255,255,0.08), transparent 40%)',
          pointerEvents: 'none',
        },
      }}
      aria-busy
    >
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 1,
          backgroundColor: alpha('#ffffff', 0.06),
          border: `1px solid ${alpha('#ffffff', 0.08)}`,
          boxShadow: `0 20px 50px ${alpha('#000000', 0.24)}`,
        }}
      >
        <CircularProgress sx={{ color: 'text.primary' }} />
      </Box>
    </Box>
  );
}
